// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
var MailIcons;
(function (MailIcons) {
    MailIcons["Accounts"] = "Accounts";
    MailIcons["Broom"] = "Broom";
    MailIcons["ChevronDownSmall"] = "ChevronDownSmall";
    MailIcons["ChevronRightSmall"] = "ChevronRightSmall";
    MailIcons["ChevronUpSmall"] = "ChevronUpSmall";
    MailIcons["ChromeMinimize"] = "ChromeMinimize";
    MailIcons["CoffeeScript"] = "CoffeeScript";
    MailIcons["DateTime2"] = "DateTime2";
    MailIcons["DietPlanNotebook"] = "DietPlanNotebook";
    MailIcons["Dislike"] = "Dislike";
    MailIcons["DislikeSolid"] = "DislikeSolid";
    MailIcons["Drm"] = "Drm";
    MailIcons["FabricMovetoFolder"] = "FabricMovetoFolder";
    MailIcons["Fax"] = "Fax";
    MailIcons["FileBug"] = "FileBug";
    MailIcons["Giftbox"] = "Giftbox";
    MailIcons["IRMForward"] = "IRMForward";
    MailIcons["IRMReply"] = "IRMReply";
    MailIcons["LikeSolid"] = "LikeSolid";
    MailIcons["Memo"] = "Memo";
    MailIcons["MultiSelectMirrored"] = "MultiSelectMirrored";
    MailIcons["NotePinned"] = "NotePinned";
    MailIcons["OutOfOffice"] = "OutOfOffice";
    MailIcons["Pin"] = "Pin";
    MailIcons["QuickNote"] = "QuickNote";
    MailIcons["Read"] = "Read";
    MailIcons["ReadingMode"] = "ReadingMode";
    MailIcons["ReceiptCheck"] = "ReceiptCheck";
    MailIcons["ReceiptForward"] = "ReceiptForward";
    MailIcons["ReceiptReply"] = "ReceiptReply";
    MailIcons["RecurringTask"] = "RecurringTask";
    MailIcons["RevToggleKey"] = "RevToggleKey";
    MailIcons["ShoppingCart"] = "ShoppingCart";
    MailIcons["Suitcase"] = "Suitcase";
    MailIcons["UserOptional"] = "UserOptional";
    MailIcons["Vacation"] = "Vacation";
    MailIcons["VerifiedBrand"] = "VerifiedBrand";
    MailIcons["VoicemailForward"] = "VoicemailForward";
    MailIcons["VoicemailIRM"] = "VoicemailIRM";
    MailIcons["VoicemailReply"] = "VoicemailReply";
})(MailIcons || (MailIcons = {}));
export default MailIcons;
//# sourceMappingURL=MailIcons.js.map